export const initAccordionListeners = () => {
    const titles = Array.from(document.querySelectorAll(".accordion_title"));
    if (!titles.length) return;

    // Массив пар: [оригинал, клон]
    const pairs = titles.map((title) => {
        if (!title || !(title instanceof Element)) return null;

        const cloned = title.cloneNode(true);
        if (!cloned) return null;

        cloned.addEventListener("pointerdown", () => {
            const menu = cloned.closest(".menu");
            const accordions = menu ? menu.querySelectorAll(".accordion") : [];

            const currentAccordion = cloned.closest(".accordion");
            if (!currentAccordion) return;

            const currentBody = currentAccordion.querySelector(".accordion_body");
            if (!currentBody) return;

            const isActive = currentAccordion.classList.contains("active");

            // Закрыть все аккордеоны
            accordions.forEach((accordion) => {
                const body = accordion.querySelector(".accordion_body");
                if (!body) return;

                accordion.classList.remove("active");
                body.style.maxHeight = null;
                body.style.paddingTop = "0";
                body.style.paddingBottom = "0";
            });

            // Открыть текущий
            if (!isActive) {
                currentAccordion.classList.add("active");
                const isAccordionForm = currentAccordion.classList.contains("accordion_form");
                const paddingBottom = isAccordionForm ? 30 : 15;
                const paddingTop = isAccordionForm ? 0 : 10;
                const offsetWidthPadding = isAccordionForm ? 45 : 30;

                requestAnimationFrame(() => {
                    currentBody.style.paddingTop = `${paddingTop}rem`;
                    currentBody.style.paddingBottom = `${paddingBottom}rem`;
                    const scrollHeight = currentBody.scrollHeight;
                    currentBody.style.maxHeight = `${scrollHeight + offsetWidthPadding}px`;
                });
            }
        });

        return [title, cloned];
    });

    // Теперь делаем замену, когда всё готово
    pairs.forEach((pair) => {
        if (!pair) return;
        const [original, clone] = pair;
        original.replaceWith(clone);
    });
};

// Функция на тот случай, если нужно открыть конкретный аккордион программно
export const openAccordion = (accordion) => {
    if (!accordion) {
        console.warn(`[openAccordion] Аккордеон не был передан: ${accordion}`);
        return;
    }

    const menu = accordion.closest(".menu");
    const accordions = menu ? menu.querySelectorAll(".accordion") : [];

    // Закрыть все аккордеоны
    accordions.forEach((acc) => {
        const body = acc.querySelector(".accordion_body");
        if (!body) return;
        acc.classList.remove("active");
        body.style.maxHeight = null;
        body.style.paddingTop = "0";
        body.style.paddingBottom = "0";
    });

    // Открыть нужный
    accordion.classList.add("active");
    const body = accordion.querySelector(".accordion_body");
    if (!body) return;

    const isAccordionForm = accordion.classList.contains("accordion_form");
    const paddingBottom = isAccordionForm ? 30 : 15;
    const paddingTop = isAccordionForm ? 0 : 10;
    const offsetWidthPadding = isAccordionForm ? 45 : 30;

    requestAnimationFrame(() => {
        body.style.paddingTop = `${paddingTop}rem`;
        body.style.paddingBottom = `${paddingBottom}rem`;
        const scrollHeight = body.scrollHeight;
        body.style.maxHeight = `${scrollHeight + offsetWidthPadding}px`;
    });
};
